import { fromJS } from 'immutable'
import * as ReducerActions from './actions'

const initialState = fromJS({
    data: {
        rubros: undefined,
        subrubros: undefined,
        superRubros: undefined,
        rubroEdit: undefined,
        subrubroEdit: undefined,
        subrubrosPicking: undefined
    }
})

export default function testReducer(state = initialState, action) {
    
    if(action.type === ReducerActions.SET_RUBROS){
        return state.setIn(["data", "rubros"], action.payload)
    }

    if(action.type === ReducerActions.SET_SUPERRUBROS_COMBO){
        return state.setIn(["data", "superRubros"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_RUBRO){
        return state.setIn(["data", "rubroEdit"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_SUBRUBRO){
        return state.setIn(["data", "subrubroEdit"], action.payload)
    }

    if(action.type === ReducerActions.SET_SUBRUBROS){
        return state.setIn(["data", "subrubros"], action.payload)
    }

    if(action.type === ReducerActions.SAVE_SUBRUBROS_PICKING){
        return state.setIn(["data", "subrubrosPicking"], action.payload)
    }

    return state
}